import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Joins class names, letting a later utility win over an earlier one.
 *
 * `clsx` alone would produce `px-4 px-2`, and which of the two applies is
 * then decided by the order Tailwind happened to emit them in the stylesheet
 * — not by the order they appear here. That makes a `className` prop
 * unreliable precisely when it matters: overriding a component's default.
 * `twMerge` resolves conflicts by keeping the last, which is what every
 * caller assumes is happening.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map